
const CaseStudiesGrid = () => {
  const caseStudies = [
    {
      company: "EcoHome Essentials",
      industry: "Sustainable Home Products",
      challenge: "Limited to US market with 15% growth plateau",
      solution: "Expanded to EU and Canada with localized marketing",
      results: {
        revenue: "320% increase",
        markets: "5 new countries",
        timeline: "8 months"
      },
      image: "https://public.readdy.ai/ai/img_res/378751b3bbf04f38d941352ed4d6b978.jpg",
      testimonial: "The team's expertise in EU regulations saved us months of research. We're now our category leader in 3 European markets.",
      author: "Sarah Mitchell, Founder"
    },
    {
      company: "TechGear Pro",
      industry: "Electronics Accessories",
      challenge: "High competition in domestic market, declining margins",
      solution: "Identified underserved Asian markets and optimized for mobile commerce",
      results: {
        revenue: "450% increase",
        markets: "7 new countries",
        timeline: "6 months"
      },
      image: "https://readdy.ai/api/search-image?query=Modern%20technology%20accessories%20and%20electronic%20gadgets%2C%20sleek%20tech%20products%20with%20professional%20product%20photography%2C%20high-tech%20devices%20with%20clean%20minimalist%20background&width=600&height=400&seq=case-techgear&orientation=landscape",
      testimonial: "Their market research was spot-on. We found profitable niches we never knew existed and our international sales now exceed domestic.",
      author: "David Chen, CEO"
    },
    {
      company: "Artisan Jewelry Co",
      industry: "Handcrafted Jewelry",
      challenge: "Seasonal sales fluctuations and limited customer base",
      solution: "Leveraged cultural preferences to enter luxury markets in Asia and Middle East",
      results: {
        revenue: "280% increase",
        markets: "4 new countries",
        timeline: "10 months"
      },
      image: "https://readdy.ai/api/search-image?query=Elegant%20handcrafted%20artisan%20jewelry%20and%20luxury%20accessories%2C%20beautiful%20handmade%20jewelry%20pieces%20with%20sophisticated%20styling%2C%20premium%20jewelry%20photography%20with%20artistic%20background&width=600&height=400&seq=case-jewelry&orientation=landscape",
      testimonial: "They understood our brand's story and helped us connect with customers who truly appreciate handcrafted quality.",
      author: "Maria Rodriguez, Creative Director"
    },
    {
      company: "FitLife Nutrition",
      industry: "Health & Wellness",
      challenge: "Regulatory hurdles preventing international expansion",
      solution: "Navigated complex supplement regulations and established compliant distribution",
      results: {
        revenue: "380% increase",
        markets: "6 new countries",
        timeline: "12 months"
      },
      image: "https://readdy.ai/api/search-image?query=Health%20and%20wellness%20nutrition%20supplements%20and%20fitness%20products%2C%20clean%20modern%20supplement%20bottles%20and%20wellness%20products%2C%20professional%20health%20product%20photography%20with%20fitness%20theme&width=600&height=400&seq=case-fitlife&orientation=landscape",
      testimonial: "The regulatory expertise was invaluable. We're now compliant in markets we thought were impossible to enter.",
      author: "James Thompson, Operations Director"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Success Stories That Inspire
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From small startups to established brands, see how our clients have transformed 
            their businesses through strategic international expansion.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {caseStudies.map((study, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
              <img 
                src={study.image}
                alt={study.company}
                className="w-full h-64 object-cover"
              />
              
              <div className="p-8">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-bold text-gray-900">{study.company}</h3>
                  <span className="text-sm text-teal-600 font-medium">{study.industry}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Challenge:</h4>
                    <p className="text-gray-600">{study.challenge}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Solution:</h4>
                    <p className="text-gray-600">{study.solution}</p>
                  </div>
                </div>
                
                <div className="grid grid-cols-3 gap-4 mb-6 p-4 bg-white rounded-lg">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-teal-600">{study.results.revenue}</div>
                    <div className="text-sm text-gray-600">Revenue Growth</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-teal-600">{study.results.markets}</div>
                    <div className="text-sm text-gray-600">New Markets</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-teal-600">{study.results.timeline}</div>
                    <div className="text-sm text-gray-600">Timeline</div>
                  </div>
                </div>
                
                <blockquote className="border-l-4 border-teal-500 pl-4 italic text-gray-700 mb-4">
                  "{study.testimonial}"
                </blockquote>
                
                <div className="text-sm text-gray-600">
                  — {study.author}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesGrid;
